<div *ngIf="data">

    <!-- sports -->
    <div class="game-wrap" *ngIf="!events.races.includes(eventId) || (eventId == 'in_play')">
        
        <div class="row oneX2">
            <div class="col-md-7"></div>
            <div class="col-md-5 px-lg-0">
                <div class="h-backLay">
                    <div class="btn-group">
                        <span>1</span>
                    </div>
                    <div class="btn-group">
                        <span>X</span>
                    </div>
                    <div class="btn-group">
                        <span>2</span>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- event match start-->
        <div *ngFor="let dt of data;trackBy:trackByIndex;">
            <div class="listuiscreen" *ngIf="dt?.name">
                <div class="sub_path competition-ttile">
                    <p>{{dt?.name}}</p>
                </div>
            </div>
            <!-- <div class="competition-head">
                <h3>{{dt?.name}}</h3>
            </div> -->
            <div class="row mx-0 align-items-center" *ngFor="let item of dt?.data;trackBy:trackByIndex;">
                <div class="col-md-5 col-9 px-1">
                    
                    <div class="date-eventname">
                        <div class="inplay_img" *ngIf="eventId == 'in_play'">
                            <!-- <img class="" src="assets/img/icons/{{item?.event_type_id}}.svg" alt=""> -->
                            <img class="" src="https://speedcdn.io/assets/parker-client/icons/{{item?.event_type_id}}.svg" alt="">
                        </div>
                        <div class="date_ename">
                            <span class="date">
                                {{(item.open_date_format) ? (item.open_date_format | date : 'dd-MM-YYY hh:mm a') : item.market_start_time_format | date : 'dd-MM-YYY hh:mm a'}} 
                                <span class="green-round" *ngIf="item.in_play == 1"></span>
                            </span>
                            <a href="javascript:void(0);" [routerLink]="['/event/detail', item.event_id]">
                                <b>
                                    <span class="teamvsname">{{(item.name) ? item.name : item.market_name}}</span>
                                </b>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-3 px-0">
                    <ul class="tv-bm-fancy">
                        <li *ngIf="item.bm_active == 1">
                            <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/icons/bm.svg">
                        </li>
                        <li *ngIf="item.tv_channel != ''">
                            <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/icons/tv.svg">
                        </li>
                        <li *ngIf="item.fancy_active == 1">
                            <img class="img-fluid" src="https://speedcdn.io/assets/parker-client/icons/fancy-icon.svg">
                        </li>
                        <li class="custom" *ngIf="item.custom_active != ''">
                            <i class="fa-duotone fa-square-{{item.custom_active | lowercase}}"></i>
                        </li>
                    </ul>
                </div>
                <div class="col-md-5 px-0 d-flex">
                    <div class="h-backLay">
                        <div class="btn-group">
                            <button class="back {{odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price : '-' }}</button>
                            <button class="lay {{odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price : '-' }}</button>
                            <!-- <span class="suspended">suspended</span> -->
                        </div>
                        <div class="btn-group">
                            <button class="back {{odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price : '-' }}</button>
                            <button class="lay {{odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price : '-' }}</button>
                        </div>
                        <div class="btn-group">
                            <button class="back {{odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price : '-' }}</button>
                            <button class="lay {{odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.key}}">{{!(odds[item?.market_id] && odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price : '-' }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- event match end-->

        <!-- NO EVENTS TO DISPLAY -->
        <div class="mx-0 align-items-center" *ngIf="datalength == 0">
            <h2 class="no-event">NO EVENTS TO DISPLAY</h2>
        </div>

    </div>

    <!-- races -->
    <div class="horse-racing-content" *ngIf="events.races.includes(eventId)">
        <!-- <div class="horse-racing-banner">
            <img src="assets/img/bnr1.jpg" alt="" class="img-fluid">
        </div> -->
        <div class="tab-container">
            <div class="market_section twoOddsSection">
                <tabset *ngIf="events.races.includes(eventId)" class="fancyTabs">
                    <tab [heading]="item?.event_country_code" *ngFor="let item of data;trackBy:trackByIndex;">
                        <div class="bet-table-body horse-table">
                            <div class="horse-table-body">
                                <div class="bet-table-row" *ngFor="let rc of item?.data;trackBy:trackByIndex;">
                                    <div class="bet-nation-name">
                                        <div class="game-icon"><i class="fa fa-tv icon-tv"></i></div>
                                        <div class="bet-nation-game-name"><span>{{rc?.event_name}}</span></div>
                                    </div>
                                    <div class="horse-time-detail">
                                        <a *ngFor="let race of rc?.data;trackBy:trackByIndex;" href="javascript:void(0);"
                                            [routerLink]="['/event/detail', race?.event_id, race?.market_id]">
                                            <span>{{race?.market_start_time_format | date : 'HH:mm'}}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabset>
                <!-- NO EVENTS TO DISPLAY -->
                <div class="bet-table-row" *ngIf="datalength == 0">
                    <h2 class="no-event">NO EVENTS TO DISPLAY</h2>
                </div>
            </div>
        </div>
    </div>

    
</div>
